






















































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import CardModalJawabanRujukan from "@/components/modal/CardModalJawabanRujukan.vue";
import CardModalKasusSkdp from "@/components/modal/CardModalKasusSkdp.vue";
import DataRujukan from "@/services/DataRujukan";
import { storeSoap } from "@/store/modules/soap";
import { storeJawabanRujukan } from "@/store/modules/jawabanrujukan";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import moment from "moment";
import http from "@/axios/http-common";
import { confirmRemove } from "@/utility/CommonHelper";
import SuratJawabanRujukan from "@/services/SuratJawabanRujukan";

@Component({
  components: {
    CardModalTtd,
    CardModalJawabanRujukan,
    CardModalKasusSkdp
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class CardSuratJawabanRujukan extends Vue {
  @Prop() readonly register!: string;
  @Prop() readonly rm!: string;
  isReadOnly!: () => boolean;

  get readOnlyMode(): boolean {
    return this.isReadOnly();
  }
  sess_login = this.stateuser;
  modalTtd = false;
  modalJawabanKonsul = false;
  modalKasusSkdp = false;
  pageTab = "tab-soap";
  dataJawabanRujukan = {};
  deleting = false;

  get stateDetailJawabanRujukan() {
    const dt = storeJawabanRujukan.detailJawabanRujukan;
    if (!dt || dt.id == null) return null;
    return String(dt["register"]) === String(this.register) ? dt : null;
  }

  get stateDataJawabanRujukan() {
    return storeJawabanRujukan.jawabanRujukan;
  }

  get statesoapdetail() {
    return storeSoap.detailSoap;
  }

  get soapRegister() {
    return this.statesoapdetail.filter(
      item => String(item.register_id) === String(this.register)
    );
  }
  get statesoapdata() {
    return storeSoap.soap;
  }

  get stateuser() {
    return userModule.user;
  }

  get canMakeJawaban() {
    if (this.readOnlyMode) return false;
    return (
      this.stateuser.profesi == "Dokter" &&
      ((this.stateuser.unit_id != "01" && this.soapRegister.length > 0) ||
        this.stateuser.unit_id == "01")
    );
  }

  get isUserDokter() {
    return this.stateuser?.profesi == "Dokter";
  }

  get canEdit() {
    if (this.readOnlyMode) return false;
    return (
      this.stateuser.profesi == "Dokter" &&
      this.stateDetailJawabanRujukan &&
      this.stateuser.id == this.stateDetailJawabanRujukan?.dokter["id"]
    );
  }

  mounted() {
    storeJawabanRujukan.actJawabanRujukan_on_reg(this.register);
  }

  @Watch("register")
  onRegisterChange() {
    storeJawabanRujukan.actJawabanRujukan_on_reg(this.register);
  }

  backPageSoap() {
    this.$emit("pageTab", this.pageTab);
  }

  passTtd(value) {
    appModule.setLoading(true);
    // console.log(value);
    const dt = DataRujukan.saveDataTtdJawabanRujukan(
      this.register,
      this.sess_login["id"],
      value
    );
    dt.then(dt => {
      appModule.setLoading(false);
      // console.log(dt);
      if (dt["status"] != 1) {
        appModule.addMsgTtd(dt["data"]["message"]);
        this.modalTtd = true;
        // appModule.sendErrorAlert(dt["err"]);
      } else {
        appModule.NoticeDelay("Berhasil Tanda Tangan Surat Jawaban Rujukan");
        this.modalTtd = false;
        appModule.addMsgTtd("");
        storeJawabanRujukan.actJawabanRujukan_on_reg(this.register);
      }
    });
  }

  cetakJawabanRujukan() {
    const routeData =
      http.getAPI() +
      "/surat-jawaban-rujukan/" +
      this.stateDetailJawabanRujukan["id"] +
      "/pdf";
    window.open(routeData, "_blank");
  }

  editJawabanRujukan() {
    this.dataJawabanRujukan = this.stateDetailJawabanRujukan;
    this.modalJawabanKonsul = true;
  }

  showModalTtd() {
    this.modalTtd = true;
  }

  showModalJawabanRujukan() {
    this.dataJawabanRujukan = {};
    this.modalJawabanKonsul = true;
  }

  formatTgl(value) {
    const dd = value.substr(0, 2);
    const mm = value.substr(3, 2);
    const yyyy = value.substr(6, 4);
    return yyyy + "-" + mm + "-" + dd;
  }

  getHumanDate(date) {
    return date ? moment(date).format("DD MMMM YYYY") : "";
  }

  getHumanDateTime(date) {
    return date ? moment(date).format("DD MMMM YYYY HH:mm:ss") : "";
  }

  remove() {
    if (!this.deleting) {
      if (confirmRemove("Surat Jawaban Rujukan")) {
        this.deleting = true;

        SuratJawabanRujukan.remove(this.stateDetailJawabanRujukan?.id)
          .then(resp => {
            if (resp.status == 1) {
              appModule.NoticeDelay(resp.message);

              storeJawabanRujukan.actJawabanRujukan_on_reg(this.register);
            }
          })
          .finally(() => {
            this.deleting = false;
          });
      }
    }
  }
}
